import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';

import { sendInviteRequest } from 'services/api/social-ecomm';

import Button from 'shared-components/Button/Button';
import styles from './EmailForm.module.css';

const EmailForm = ({
  inviteCode,
  product,
  creatingTeam,
  onInviteSent,
  onInviteError,
}) => {
  const [sendingInvite, setSendingInvite] = useState(false);
  const { register, handleSubmit, errors } = useForm({
    shouldFocusError: true,
    reValidateMode: 'onSubmit',
  });
  const { email: emailError } = errors;
  const disabledButton = creatingTeam || sendingInvite;

  const onSubmit = async (formData) => {
    const { email } = formData;

    const data = {
      recipientDestination: email,
      inviteCode,
      ...(product && { shareSku: product.sku }),
    };
    try {
      setSendingInvite(true);
      await sendInviteRequest(data);
      setSendingInvite(false);
      onInviteSent(true);
    } catch (error) {
      setSendingInvite(false);
      onInviteError('Oops! Something went wrong.');
    }
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <input
        className={classNames(styles.input, {
          [styles.error]: emailError && emailError.message,
        })}
        name="email"
        placeholder="Enter email address"
        onChange={(e) => {
          e.target.value = e.target.value.trim();
        }}
        ref={register({
          required: 'This field is required.',
          pattern: {
            value:
              /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
            message: 'Please enter a valid email address.',
          },
        })}
      />
      {emailError && emailError.message && (
        <p className={styles.errorMessage}>{errors.email.message}</p>
      )}
      <Button type="submit" className={styles.button} disabled={disabledButton}>
        Send Invite
      </Button>
    </form>
  );
};

EmailForm.propTypes = {
  inviteCode: PropTypes.string.isRequired,
  product: PropTypes.shape({
    productId: PropTypes.string,
    productName: PropTypes.string,
    retailPrice: PropTypes.string,
    salePrice: PropTypes.string,
    sku: PropTypes.string,
  }),
  creatingTeam: PropTypes.bool.isRequired,
  onInviteSent: PropTypes.func.isRequired,
  onInviteError: PropTypes.func.isRequired,
};

EmailForm.defaultProps = {
  product: null,
};

export default EmailForm;
